import * as Apollo from '@apollo/client';

import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import * as Types from 'apollo/queries/autogenerate/operations';
import { isPlusUser } from 'utils/user-types';

export default function useIsPlusUser(
  options?: Apollo.QueryHookOptions<
    Types.ConsumerStatusSummaryQuery,
    Types.ConsumerStatusSummaryQueryVariables
  >
) {
  const { data: consumerStatusSummary } = useConsumerStatusSummaryQuery(
    options
  );
  const hokatsuStatus = consumerStatusSummary?.houkatsuStatus.status;
  const kycStatus = consumerStatusSummary?.KYCApplicationStatus.status;

  return isPlusUser(kycStatus, hokatsuStatus);
}
